// extracted by mini-css-extract-plugin
export default {"main_archive":"Archive_main_archive__PudJk","archive_header_main":"Archive_archive_header_main__7LO+E","grid_archive":"Archive_grid_archive__fvlKz"};